import React from 'react';

import {
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import {
  verifyEmail,
  resendChangeEmail,
} from '../../../Header/Account/thunk';

import EditEmailDialog from './EditEmailDialog';

import type {
  UserType,
} from '@/types/domain/user/redux';

import TextFieldComp from '@/components/TextFieldComp';
import {
  userSlice,
} from '@/domain/user/redux';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー */
  user: UserType;
}

const VerifyEmail: React.FC<Props> = ({ user }) => {
  const [isOpenEditEmailDialog, setIsOpenEditEmailDialog] = React.useState(false);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{
    code: string;
  }>({
    defaultValues: {
      code: '',
    },
  });
  const onSubmit = (input: {
    code: string;
  }) => {
    dispatch(verifyEmail(input.code));
  };
  const content = `「${user.attributes?.email || ''}」に認証コードを送りました。メールを確認し検証を完了してください。「認証コードを再送する」ボタンを押すと、認証コードを再送できます。`;
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h2 style={{ textAlign: 'center' }}>
          メールアドレスの検証
        </h2>
        <p>{content}</p>
        <p>※メールアドレスに間違いがある場合は、「メールアドレスを変更する」ボタンをおして、メールアドレスの変更をお願いします。</p>
        <TextFieldComp
          type="text"
          control={control}
          rules={{
            required: '必須項目です',
          }}
          name="code"
          label="認証コード"
          placeholder=""
          errors={errors}
        />
        <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
          メールアドレスに送られた認証コードを入力して認証ボタンを押してください。
        </div>
        <div style={{ textAlign: 'center', margin: '10px 0' }}>
          <Button
            size="large"
            type="submit"
            variant="contained"
            color="primary"
          >
            認証
          </Button>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button size="small" onClick={() => dispatch(resendChangeEmail())}>
            認証コードを再送する
          </Button>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button size="small" onClick={() => setIsOpenEditEmailDialog(true)}>
            メールアドレスを変更する
          </Button>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button size="small" onClick={() => dispatch(userSlice.actions.setMode('signin'))}>
            ログインはこちら
          </Button>
        </div>
      </form>
      <EditEmailDialog
        isOpen={isOpenEditEmailDialog}
        close={() => setIsOpenEditEmailDialog(false)}
      />
    </div>
  );
};

export default VerifyEmail;
